module.exports = __webpack_public_path__ + "resources/collaborative-document-3c15f5d4e1c2ff362e4c12bf3e653b4b.svg";